import { Pipe, PipeTransform } from '@angular/core';
import { ChurchUnit } from '../models';
import * as Config from '../tokens/constants.tokens';

@Pipe({
  name: 'churchUnit'
})
export class ChurchUnitPipe implements PipeTransform {

  transform(unit: ChurchUnit, args?: any): any {
    if (!unit) {
      return '';
    }

    if (unit.unitNumber && unit.unitNumber !== Config.Constants.unassignedUnitNumber) {
      return `${unit.name} (${unit.unitNumber})`;
    }

    return unit.name;
  }

}
